var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
const SvgInfoLetter28 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4047 7.45238C15.0484 7.45238 16.3809 6.1199 16.3809 4.47619C16.3809 2.83249 15.0484 1.5 13.4047 1.5C11.761 1.5 10.4285 2.83249 10.4285 4.47619C10.4285 6.1199 11.761 7.45238 13.4047 7.45238ZM11.6191 9.8334H9.2381V13.4048H11.6191V22.9286H9.2381V26.5H18.7619V22.9286H16.381V9.8334H16.381H11.6191Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgInfoLetter28);
const Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;